import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// ---- View-as mode ----
// When an admin selects "View as principal" the frontend appends ?as=<id> to
// EVERY API call. Reads come back scoped to that principal, and portfolio
// writes (projects, notes, invoicing) apply ON BEHALF of them. Firm-wide
// admin actions (re-feed, report notes, personnel) are blocked server-side
// until the admin switches back to Firm-wide.
let _viewAsId = null;
export const setApiViewAs = (id) => { _viewAsId = id || null; };
export const getApiViewAs = () => _viewAsId;

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mm_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (_viewAsId) {
    // Merge into the existing params (axios accepts object or URLSearchParams).
    const existing = config.params || {};
    if (existing instanceof URLSearchParams) {
      if (!existing.has("as")) existing.set("as", _viewAsId);
      config.params = existing;
    } else if (!("as" in existing)) {
      config.params = { ...existing, as: _viewAsId };
    }
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("mm_token");
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
